import React from 'react';
import { KPI, useDates } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useSettingContextInComponent } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const LeadAnalisiKPISet = ({ dataProviderName, filters: defaultFilters }) => {

    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);

    const { getComparableTimeframe } = useDates();

    return (drawable && 
        <Box className="mtska-kpi-set" sx={{ marginBottom: '0px' }}>
            <KPI
                title="Leads"
                dataProviderName={'statisticsviews/item/count/opportunities/lead'}
                filters={filterModel}
                compareFilters={
                    {
                        ...getComparableTimeframe(filterModel, 'registered_at'), 
                        timeline: {
                            collection:'views_opportunities_lead',
                            field:'registered_at',
                            granularity:'month'
                        }
                    }
                }
                comparePositiveCondition={'straight'}
            />
            <KPI
                title="Costs"
                dataProviderName={'statisticsviews/item/sumfinancial/advertisings/advertisingCost/value'}
                filters={{
                    items: [
                        ...(filterModel?.items || [])
                            .filter(item =>
                                item.field == "registered_at" ||
                                item.field === '_related_source_name' ||
                                item.field === '_related_area_name' ||
                                item.field === '_related_shop_name'
                            )
                    ]
                }}
                format='currency'
                compactformat={false}
                compareFilters={
                    {
                        ...getComparableTimeframe(filterModel, 'registered_at'), 
                        timeline: {
                            collection:'views_advertisings_advertisingcost',
                            field:'registered_at',
                            granularity:'month',
                            sumfield:'value'
                        }
                    }
                }
                comparePositiveCondition={'inverse'}
            />
            <KPI
                title="CPL"
                dataProviderName={'statisticsviews/item/costperunit/opportunities/lead'}
                filters={filterModel}
                format='currency'
                compactformat={false}
                decimaldigits={'standard'}
                compareFilters={getComparableTimeframe(filterModel, 'registered_at')}
                comparePositiveCondition={'inverse'}
            />
            {/* <KPI
                title="Obiettivo"
                dataProviderName={'statisticsviews/item/sumgoal/commercials/areasource/leadGoal'}
                filters={filterModel}
                compactformat={false}
            /> */}
        </Box>
    )
}

export default LeadAnalisiKPISet;
